<template>
    <v-card>
        <v-card-title>
            API-keys
            <v-spacer></v-spacer>
            <v-btn
                    color="success"
                    @click="openEditDialog({ title:'Add', id: 0, domain:null, status:2, date_expired:null } )"
                    fab
                    small
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <div v-if="keys.length > 0">
                <v-card
                        v-for="(item, index) in keys"
                        :key="index"
                        class="mb-3"
                >
                    <v-card-text>
                        <v-layout align-baseline>
                            <v-label>Domain:</v-label>
                            <div class="body-1 ml-2">{{ item.domain === null || item.domain === '' ? 'Undefined' : item.domain }}</div>
                        </v-layout>
                        <v-layout align-baseline>
                            <v-label>Public-key:</v-label>
                            <div class="body-1 ml-2">{{ item.public_key }}</div>
                        </v-layout>
                        <v-layout align-baseline>
                            <v-label>Secret-key:</v-label>
                            <div class="body-1 ml-2">{{ item.secret_key }}</div>
                        </v-layout>
                        <v-layout align-baseline>
                            <v-label>Status:</v-label>
                            <v-chip
                                    class="ml-2"
                                    small
                                    :color="statusColor(item.status) + ' lighten-4'"
                            >{{ item.status_alias }}</v-chip>
                        </v-layout>
                        <v-layout align-baseline>
                            <v-label>Date created:</v-label>
                            <div class="body-1 ml-2">{{ dFormat( item.date_created, "mmmm d, yyyy, HH:MM:ss" )}}</div>
                        </v-layout>
                        <v-layout align-baseline>
                            <v-label>Date expired:</v-label>
                            <div class="body-1 ml-2">{{ dFormat( item.date_expired, "mmmm d, yyyy" )}}</div>
                        </v-layout>
                        <v-layout v-if="item.create_transaction !== null && item.create_transaction !== false" align-baseline>
                            <v-label>Create transaction:</v-label>
                            <div class="body-1 ml-2">
                                <a :href="item.create_transaction.link" target="_blank">
                                        {{item.create_transaction.transaction_id}}
                                </a>
                            </div>
                        </v-layout>
                        <v-layout v-if="item.transactions.length > 0" align-baseline style="margin-top: .75em">
                            <v-expansion-panels
                                    v-model="item.transactions_panel"
                            >
                                <v-expansion-panel>
                                    <v-expansion-panel-header>All transactions</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-simple-table>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Date</th>
                                                    <th class="text-left">Type</th>
                                                    <th class="text-left">Expired Date</th>
                                                    <th class="text-left">Link</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="transaction in item.transactions" :key="transaction.id">
                                                    <td>{{ dFormat( transaction.date_created, "mmmm d, yyyy HH:MM:ss" ) }}</td>
                                                    <td>{{ transaction.type_alias }}</td>
                                                    <td>{{ dFormat( transaction.date_expired, "mmmm d, yyyy HH:MM:ss" ) }}</td>
                                                    <td><a :href="transaction.link" target="_blank">
                                                        {{transaction.transaction_id}}
                                                    </a></td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="openEditDialog({ title:'Edit', ...item })">Edit</v-btn>
                        <v-btn text @click="openDeleteDialog(item)" color="red">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </v-card-text>

        <v-dialog v-model="editDialog" persistent max-width="600px">
            <v-form
                    v-model="valid"
                    lazy-validation
                    @submit.prevent="onEditSubmit"
                    @keyup.native.enter="onEditSubmit"
                    ref="formEditKey"
            >
                <v-card>
                    <v-card-title>{{edit.title}}</v-card-title>

                    <v-card-text>
                        <v-text-field
                                v-model="edit.domain"
                                label="Domain"
                                :disabled="loading"
                                outlined
                                :rules="rules.urlRules"
                        />
                        <v-radio-group v-model="edit.status" label="Status" class="mt-0">
                            <v-radio
                                    v-for="(i, index) in apikey_status_list"
                                    :key="index"
                                    :label="i"
                                    :value="index"
                                    :color="statusColor(index)"
                            ></v-radio>
                        </v-radio-group>

                        <v-menu
                                v-model="edit.menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="dFormat( edit.date_expired, 'mmmm d, yyyy' )"
                                        label="Date expired"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                >
                                </v-text-field>
                            </template>
                            <v-date-picker
                                    v-model="edit.date_expired"
                                    @input="edit.menu = false"
                                    :show-current="true"
                                    first-day-of-week="1"
                                    color="primary"
                                    header-color="primary"
                            ></v-date-picker>
                        </v-menu>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="info"
                                text
                                :loading="loading"
                                :disabled="loading"
                                type="submit"
                        >Save</v-btn>
                        <v-btn color="dark" text @click="closeEditDialog" :loading="loading" :disabled="loading">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="deleteDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>Delete</v-card-title>
                <v-card-text>
                    <v-label>Are you sure?</v-label>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="del" :loading="loading" :disabled="loading">Delete</v-btn>
                    <v-btn color="dark" text @click="closeDeleteDialog" :loading="loading" :disabled="loading">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>
<script>

    const dateFormat = require('dateformat');

    export default {
        name: "UserLandingPageApiKeys",
        props: {
            id: {
                type: String, default: 0
            }
        },
        data(){
            return{
                loading: false,
                editDialog: false,
                edit: {
                    title        : '',
                    id           : null,
                    domain       : null,
                    status       : null,
                    date_expired : null,
                    dmenu         : false
                },
                deleteDialog: false,
                deleteItemId: null,
                keys: [],
                valid: false,
                rules      : {
                    required : value => !!value || 'Required field.',
                    urlRules : [
                        value => ( /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/.test(value) || value === null || value === '') || 'Domain must be valid. ( example.com )'
                    ]
                },
                apikey_status_list: [],
            }
        },
        created() {
            this.getList();
        },
        methods:{

            dFormat( date, mask, utc, gmt ){
                return dateFormat( date, mask, utc, gmt );
            },

            statusColor( status = null ){
                const colors = {
                    '0': 'red',
                    '1': 'green',
                    '2': 'yellow',
                };

                return colors.hasOwnProperty(status) ? colors[status] : 'grey'
            },

            closeEditDialog() {
                this.editDialog = false;
                this.edit = {
                    title        :'',
                    id           : null,
                    domain       : null,
                    status       : null,
                    date_expired : null,
                    dmenu        : false
                };
                this.valid = false;
            },

            openEditDialog( item ) {
                let date = new Date();

                this.editDialog = true;
                this.edit = {
                    title        : item.title,
                    id           : item.id,
                    domain       : item.domain,
                    status       : item.status,
                    date_expired : item.date_expired !== null ? item.date_expired : this.dFormat( date, 'yyyy-mm-dd'),
                    dmenu        : false
                };
                this.valid = true;
            },

            closeDeleteDialog() {
                this.deleteDialog = false;
                this.deleteItemId = null;
            },
            openDeleteDialog( item ) {
                this.deleteDialog = true;
                this.deleteItemId = item.id;
            },

            getList(){

                this.loading = true;
                this.axios.post( 'user/lpApiKey', JSON.stringify( {
                    method: 'show',
                    user_id: this.id,
                } ) )
                    .then((response)=>{

                        const params = response.data;

                        if( params.status === 'success'  ){

                            this.keys = params.data.keys;

                            this.keys.map( item => {
                                item.date_expired = item.date_expired.substr(0, 10);
                                return item;
                            });
                            this.apikey_status_list = params.data.apikey_status_list;

                        } else if( params.status === 'notfound' && params.hasOwnProperty('data' ) ){

                            this.keys = params.data.keys;
                            this.apikey_status_list = params.data.apikey_status_list;

                            this.$emit('alert', {type:'warning', message: params.message});
                        }else {
                            this.$emit('alert', {type:'error', message: params.message});
                        }

                        this.loading = false;

                    }).catch(()=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    this.loading = false;
                });

            },

            onEditSubmit(){
                if( this.$refs.formEditKey.validate() ) {
                    this.save();
                }
            },

            save(){

                this.loading = true;

                console.log(this.edit);

                this.axios.post( 'user/lpApiKey', JSON.stringify( {
                    method        : 'save',
                    user_id       : this.id,
                    key_id        : this.edit.id,
                    domain        : this.edit.domain,
                    status        : this.edit.status,
                    date_expired  : this.edit.date_expired,
                } ) )
                    .then((response)=>{

                        const params = response.data;

                        if( params.status === 'success' && params.hasOwnProperty('data' ) ){

                            this.$emit('alert', {type:'success', message: params.message});
                        } else {
                            this.$emit('alert', {type:'error', message: params.message});
                        }

                        this.loading = false;
                        this.closeEditDialog();

                        this.getList();

                    }).catch(()=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    this.loading = false;
                    this.closeEditDialog();
                });
            },

            del(){
                this.loading = true;

                this.axios.post( 'user/lpApiKey', JSON.stringify( {
                    method: 'delete',
                    user_id : this.id,
                    key_id  : this.deleteItemId,
                } ) )
                    .then((response)=>{

                        const params = response.data;

                        if( params.status === 'success' && params.hasOwnProperty('data' ) ){
                            this.$emit('alert', {type:'success', message: params.message});
                        } else {
                            this.$emit('alert', {type:'error', message: params.message});
                        }

                        this.loading = false;
                        this.closeDeleteDialog();

                        this.getList();

                    }).catch(()=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    this.loading = false;
                    this.closeDeleteDialog();
                });
            },

            customFilter (item, queryText, itemText) {
                console.log(item, queryText, itemText )
                const textOne = item.name.toLowerCase();
                const searchText = queryText.toLowerCase();

                return textOne.indexOf(searchText) > -1
            },

        }
    }
</script>